import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import useTable from "../../useTable";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import { Toasts } from "../../toasts";
import { ModalGestionDeuda } from "./modalGestionarDeuda";
import { PrimaryButton } from "../../../ui/buttons/Button";
import { SearchInput } from "../../../ui/inputs/Input";

const TablaActualizarDeuda = (props) => {
  let op = require("../../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [factorCambio, setFactorCambio] = useState(0);
  const [permiso] = useState({
    permiso: ""
  });

  const headCells =
    props.tipo === "comercio"
      ? [
        {
          id: "idcomercio",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "CODIGO",
          textAlign: "center",
        },
        {
          id: "ritm",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "RITM",
          textAlign: "center",
        },
        {
          id: "rif",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "RIF",
          textAlign: "center",
        },
        {
          id: "nombre",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "NOMBRE",
          textAlign: "center",
        },
        {
          id: "direccion",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "DIRECCIÓN",
          textAlign: "center",
        },
        {
          id: "reprelegal",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: " CEDULA",
          textAlign: "center",
        },
        {
          id: "opciones",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: " OPCIONES",
          textAlign: "center",
        },
      ]
      : props.tipo === "inmueble"
        ? [
          {
            id: "idinmueble",
            label: "CODIGO",
            width: "10px",
            textAlign: "center",
            backgroundColor: "rgba(5, 81, 130, 1)",
            fontSize: "10px",
            color: "white",
          },
          {
            id: "numficha",
            label: "N° FICHA",
            width: "70px",
            textAlign: "center",
            backgroundColor: "rgba(5, 81, 130, 1)",
            fontSize: "10px",
            color: "white",
          },
          {
            id: "nombrepropie",
            label: "NOMBRE PROPIETARIO",
            width: "250px",
            textAlign: "center",
            backgroundColor: "rgba(5, 81, 130, 1)",
            fontSize: "10px",
            color: "white",
          },
          {
            id: "dirinmueble",
            label: "DIRECCION",
            width: "250px",
            textAlign: "center",
            backgroundColor: "rgba(5, 81, 130, 1)",
            fontSize: "10px",
            color: "white",
          },
          {
            id: "codigocatastral",
            label: "CODIGO CATASTRAL",
            width: "100px",
            textAlign: "center",
            backgroundColor: "rgba(5, 81, 130, 1)",
            fontSize: "10px",
            color: "white",
          },
          {
            id: "cedulapropie",
            label: "CEDULA PROPIETARIO",
            width: "200px",
            textAlign: "center",
            backgroundColor: "rgba(5, 81, 130, 1)",
            fontSize: "10px",
            color: "white",
          },
          {
            id: "accion",
            label: "OPCIONES",
            width: "120px",
            textAlign: "center",
            backgroundColor: "rgba(5, 81, 130, 1)",
            fontSize: "10px",
            color: "white",
          },
        ]
        : props.tipo === "vehiculo"
          ? [
            {
              id: "placa",
              label: "PLACA",
              width: "20px",
              textAlign: "center",
              backgroundColor: "rgba(5, 81, 130, 1)",
              color: "white",
            },
            {
              id: "ritm",
              label: "RITM",
              width: "20px",
              textAlign: "center",
              backgroundColor: "rgba(5, 81, 130, 1)",
              color: "white",
            },
            {
              id: "nombrepropie",
              label: "NOMBRE",
              width: "200px",
              textAlign: "center",
              backgroundColor: "rgba(5, 81, 130, 1)",
              color: "white",
            },
            {
              id: "idvehiculo",
              label: "CÓDIGO",
              width: "20px",
              textAlign: "center",
              backgroundColor: "rgba(5, 81, 130, 1)",
              color: "white",
            },
            {
              id: "accion",
              label: "OPCIONES",
              width: "60px",
              textAlign: "center",
              backgroundColor: "rgba(5, 81, 130, 1)",
              color: "white",
            },
          ]
          : props.tipo === "rentas"
            ? [
              {
                id: "idrentas",
                label: "CODIGO",
                width: "200px",
                textAlign: "center",
                backgroundColor: "rgba(5, 81, 130, 1)",
                fontSize: "10px",
                color: "white",
              },
              {
                id: "cedrif",
                label: "CEDULA/RIF",
                width: "200px",
                textAlign: "center",
                backgroundColor: "rgba(5, 81, 130, 1)",
                fontSize: "10px",
                color: "white",
              },
              {
                id: "nombrearrendatario",
                label: "NOMBRE ARRENDATARIO",
                width: "300px",
                textAlign: "center",
                backgroundColor: "rgba(5, 81, 130, 1)",
                fontSize: "10px",
                color: "white",
              },
              {
                id: "descripcion",
                label: "RENTA",
                width: "200px",
                textAlign: "center",
                backgroundColor: "rgba(5, 81, 130, 1)",
                fontSize: "10px",
                color: "white",
              },
              {
                id: "",
                label: "OPCIONES",
                width: "60px",
                textAlign: "center",
                backgroundColor: "rgba(5, 81, 130, 1)",
                fontSize: "10px",
                color: "white",
              },
            ]
            : props.tipo === "publicidad" || props.tipo === "apuesta" || props.tipo === "licores"
              ? [
                {
                  id: "idcomercio",
                  label: "CODIGO",
                  width: "10px",
                  textAlign: "center",
                  backgroundColor: "rgba(5, 81, 130, 1)",
                  fontSize: "10px",
                  color: "white",
                },
                {
                  id: "ritm",
                  label: "RITM",
                  width: "40px",
                  textAlign: "center",
                  backgroundColor: "rgba(5, 81, 130, 1)",
                  fontSize: "10px",
                  color: "white",
                },
                {
                  id: "rif",
                  label: "RIF",
                  width: "40px",
                  textAlign: "center",
                  backgroundColor: "rgba(5, 81, 130, 1)",
                  fontSize: "10px",
                  color: "white",
                },
                {
                  id: "nombre",
                  label: "NOMBRE",
                  width: "300px",
                  textAlign: "center",
                  backgroundColor: "rgba(5, 81, 130, 1)",
                  fontSize: "10px",
                  color: "white",
                },
                {
                  id: "direccion",
                  label: "DIRECCIÓN",
                  width: "200px",
                  textAlign: "center",
                  backgroundColor: "rgba(5, 81, 130, 1)",
                  fontSize: "10px",
                  color: "white",
                },
                {
                  id: "accion",
                  label: "OPCIONES",
                  width: "80px",
                  textAlign: "center",
                  backgroundColor: "rgba(5, 81, 130, 1)",
                  fontSize: "10px",
                  color: "white",
                },
              ]
              : [];

  const txtBuscador = useRef();
  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [nomtabla, setNomtabla] = useState("");
  const [contribuyente] = useState({
    idcontribuyente: "",
    nombre: "",
    ritm: "",
    rif: "",
    direccion: "",
    montoimpu:""
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              props.tipo === "comercio" ?
                x.idcomercio.includes(target.value) ||
                (x.ritm !== null ? x.ritm.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
                x.direccion.toLowerCase().includes(target.value.toLowerCase()) ||
                x.reprelegal.toLowerCase().includes(target.value.toLowerCase()) ||
                x.rif.toLowerCase().includes(target.value.toLowerCase())
                : props.tipo === "inmueble" ?
                  x.idinmueble.includes(target.value) ||
                  (x.numficha !== null ? x.numficha.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                  (x.nombrepropie !== null ? x.nombrepropie.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                  (x.dirinmueble !== null ? x.dirinmueble.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                  x.codigocatastral.toLowerCase().includes(target.value.toLowerCase()) ||
                  (x.cedulapropie !== null ? x.cedulapropie.toLowerCase().includes(target.value.toLowerCase()) : "")
                  : props.tipo === "vehiculo" ?
                    x.idvehiculo.includes(target.value) ||
                    x.placa.toLowerCase().includes(target.value.toLowerCase()) ||
                    (x.ritm !== null ? x.ritm.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                    x.nombrepropie.toLowerCase().includes(target.value.toLowerCase())
                    : props.tipo === "rentas" ?
                      x.idrentas.includes(target.value) ||
                      x.cedrif.toLowerCase().includes(target.value.toLowerCase()) ||
                      x.nombrearrendatario.toLowerCase().includes(target.value.toLowerCase()) ||
                      x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                      : props.tipo === "publicidad" || props.tipo === "apuesta" || props.tipo === "licores" ?
                        x.idcomercio.includes(target.value) ||
                        (x.ritm !== null ? x.ritm.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                        x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
                        x.direccion.toLowerCase().includes(target.value.toLowerCase()) ||
                        x.rif.toLowerCase().includes(target.value.toLowerCase())
                        : ""


            ) {
              return x;
            }
          });
      },
    });
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const seleccionarComercios = () => {
    setActivate(true);
    setRecords([]);

    let endpoint = `${op.conexion}/api/industria/comercios`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            console.log(response.data);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        /*  setMensaje({
           mostrar: true,
           titulo: "ERROR",
           texto: error.response.data.message,
           icono: "error",
         }); */
        console.log(error);
      });
  };

  const seleccionarInmeubles = () => {
    let endpoint = op.conexion + `/api/catalogo/inmuebles`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarVehiculo = () => {
    let campos = "placa, ritm, TRIM(nombrepropie) AS nombrepropie, idvehiculo, cedulapropie, direccionpropie, status";
    let nomtab = "vehiculo";
    let orden = "idvehiculo";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRentas = () => {
    let nomtab = "rentasinmobiliarias";
    let nomid = "idtiporenta";
    let nomtab2 = "tiporentas";
    let nomid2 = "idtiporentas";
    let condi = "codigoimpuesto<6";

    let endpoint =
      op.conexion +
      `/api/aseo/aseo?nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}&condi=${condi} `;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarPublicidad = () => {
    let campos = "*";
    let nomtab = "comercio";
    let orden = "idcomercio";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarFactorCambio = () => {

    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        console.log(response.data)
        setFactorCambio(response.data.valor)

      }

    }).catch(function (error) {

      /*   setTitulo("ERROR");
        setMsg(error.response.data.message)
        setMostrar5(true)*/
      setActivate(false);

    })
  }

  useEffect(() => {
    seleccionarFactorCambio();
  }, []);

  useEffect(() => {
    txtBuscador.current.value = "";
    if (props.tipo === "comercio") {
      permiso.permiso = JSON.parse(localStorage.getItem("accactudeuindustria"));
      seleccionarComercios();
    } else if (props.tipo === "inmueble") {
      permiso.permiso = JSON.parse(localStorage.getItem("accactudeuinmue"));
      seleccionarInmeubles();
    } else if (props.tipo === "vehiculo") {
      permiso.permiso = JSON.parse(localStorage.getItem("accactudeuvehiculo"));
      seleccionarVehiculo();
    } else if (props.tipo === "rentas") {
      permiso.permiso = JSON.parse(localStorage.getItem("accactudeurenta"));
      seleccionarRentas();
    } else if (props.tipo === "apuesta") {
      permiso.permiso = JSON.parse(localStorage.getItem("accactudeuapuesta"));
      seleccionarPublicidad();
    } else if (props.tipo === "publicidad" || props.tipo === "licores") {
      permiso.permiso = JSON.parse(localStorage.getItem("accactudeuindustria"));
      seleccionarPublicidad();
    }
  }, [props.tipo]);

  const gestionarDeuda = (data) => (event) => {
    event.preventDefault();
    contribuyente.idcontribuyente = "";
    contribuyente.nombre = "";
    contribuyente.rif = "";
    contribuyente.ritm = "";
    contribuyente.direccion = "";
    contribuyente.montoimpu = "";
    if (permiso.permiso !== "" && parseInt(permiso.permiso) !== 0) {
      if (props.tipo === "comercio") {
        if (data.status === "52") {
          setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Al contribuyente no se le puede cargar deuda, esta inactivo', icono: 'informacion' });
          return;
        } else if (data.status === "57") {
          setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Al contribuyente no se le puede cargar deuda, esta inactivo', icono: 'informacion' });
          return;
        }
        contribuyente.idcontribuyente = data.idcomercio;
        contribuyente.nombre = data.nombre.trim();
        contribuyente.rif = data.rif.trim();
        contribuyente.ritm = data.ritm === null ? "" : data.ritm.trim();
        contribuyente.direccion = data.direccion === null ? "" : data.direccion.trim();
        contribuyente.montoimpu = data.montopatente === null ? "0.00" : data.montopatente.toString();
      } else if (props.tipo === "inmueble") {
        if (data.status === "62") {
          setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Al contribuyente no se le puede cargar deuda, esta inactivo', icono: 'informacion' });
          return;
        }
        contribuyente.idcontribuyente = data.idinmueble;
        contribuyente.nombre = data.nombrepropie === null ? "" : data.nombrepropie.trim();
        contribuyente.rif = data.cedulapropie === null ? "" : data.cedulapropie.trim();
        contribuyente.ritm = data.numficha === null ? "" : data.numficha.trim();
        contribuyente.direccion = data.dirinmueble === null ? "" : data.dirinmueble.trim();
        contribuyente.montoimpu = data.montoimpuesto === null ? "0.00" : data.montoimpuesto.toString();
      } else if (props.tipo === "vehiculo") {
        if (data.status === 1) {
          setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Al contribuyente no se le puede cargar deuda, esta inactivo', icono: 'informacion' });
          return;
        }
        contribuyente.idcontribuyente = data.idvehiculo;
        contribuyente.nombre = data.nombrepropie === null ? "" : data.nombrepropie.trim();
        contribuyente.rif = data.cedulapropie === null ? "" : data.cedulapropie.trim();
        contribuyente.ritm = data.placa === null ? "" : data.placa.trim();
        contribuyente.direccion = data.direccionpropie === null ? "" : data.direccionpropie.trim();
        contribuyente.montoimpu = "0.00";
      } else if (props.tipo === "rentas") {

        if (data.codigoimpuesto === 5) {
          setNomtabla("residuossolidos");
        } else {
          setNomtabla("aseo");
        }
        contribuyente.idcontribuyente = data.idrentas;
        contribuyente.nombre = data.nombrearrendatario === null ? "" : data.nombrearrendatario.trim();
        contribuyente.rif = data.cedrif === null ? "" : data.cedrif.trim();
        contribuyente.ritm = data.descripcion.trim();
        contribuyente.direccion = data.direccion === null ? "" : data.direccion.trim();
        contribuyente.montoimpu = data.montoarrendamiento === null ? "0.00" : data.montoarrendamiento.toString();
      }
      setMostrar2(true);
    } else {
      setToast({
        mostrar: true,
        titulo: "Notificación",
        mensaje:
          "No posee permiso para consultar un Contribuyente de actividades Economicas",
      });
    }
  };

  return (
    <div className="col-md-9 mx-auto">
      <div className="card col-md-12 mx-auto">
        <div className="card-body col-md-12">
          <header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
            {props.tipo === "comercio" ? (
              <h3>Actualizar Deuda Actividades Economicas</h3>
            ) : props.tipo === "inmueble" ? (
              <h3>Actualizar Deuda Inmuebles Urbanos</h3>
            ) : props.tipo === "vehiculo" ? (
              <h3>Actualizar Deuda Impuestos de Vehiculos</h3>
            ) : props.tipo === "rentas" ? (
              <h3>Actualizar Deuda Rentas Inmobilarias</h3>
            ) : props.tipo === "apuesta" ? (
              <h3>Actualizar Deuda Apuestas Licitas</h3>
            ) : props.tipo === "publicidad" ? (
              <h3>Actualizar Deuda Propaganda y Públicidad Comercial</h3>
            ) : props.tipo === "licores" ? (
              <h3>Actualizar Deuda Rentas de Licores</h3>
            ) : (
              ""
            )}
            <a type="button" className="text-light fw-bold fs-6">
              Salir <i className="fa fa-times ms-2"></i>
            </a>
          </header>
          <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
            <div className="col-4 m-0 p-0">
              <SearchInput
                ref={txtBuscador}
                onChange={handleSearch}
                placeholder="Buscar"
              />
            </div>
            <div className="col-auto m-0 p-0">
              {props.tipo === "comercio" ||
                props.tipo === "inmueble" ||
                props.tipo === "rentas" ||
                props.tipo === "apuesta" &&
                <PrimaryButton icon='fa-pen'>
                  Actualizar General
                </PrimaryButton>
              }
            </div>
          </div>
          <div className='col-12 m-0 p-0'>
            {props.tipo === "comercio" &&
              <TblContainer>
                <TblHead />
                <tbody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr key={item.idcomercio} style={{ padding: "0" }}>
                        <td className="align-baseline text-center">
                          {item.idcomercio}
                        </td>
                        <td className="align-baseline text-center">
                          {item.ritm}
                        </td>
                        <td className="align-baseline text-center">
                          {item.rif}
                        </td>
                        <td className="align-baseline text-center">
                          {item.nombre}
                        </td>
                        <td className="align-baseline text-center">
                          {item.direccion}
                        </td>
                        <td className="align-baseline text-center">
                          {item.reprelegal}
                        </td>
                        <td
                          className="align-baseline text-center"
                          style={{ width: "150px" }}
                        >
                          <button
                            onClick={gestionarDeuda(item)}
                            className="btn btn-sm btn-primary rounded-pill"
                          >
                            <i class="fas fa-pen-nib"></i> Actualizar
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
            }
            {props.tipo === "inmueble" &&
              <TblContainer>
                <TblHead />
                <tbody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr key={item.idinmueble} style={{ padding: "0" }}>
                        <td className="align-baseline text-center">
                          {item.idinmueble}
                        </td>
                        <td className="align-baseline text-center">
                          {item.numficha}
                        </td>
                        <td className="align-baseline text-center">
                          {item.nombrepropie}
                        </td>
                        <td className="align-baseline text-center">
                          {item.dirinmueble}
                        </td>
                        <td className="align-baseline text-center">
                          {item.codigocatastral}
                        </td>
                        <td className="align-baseline text-center">
                          {item.cedulapropie}
                        </td>
                        <td
                          className="align-baseline text-center"
                          style={{ width: "150px" }}
                        >
                          <button
                            onClick={gestionarDeuda(item)}
                            className="btn btn-sm btn-primary rounded-pill"
                          >
                            <i class="fas fa-pen-nib"></i> Actualizar
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
            }
            {props.tipo === "vehiculo" &&
              <TblContainer>
                <TblHead />
                <tbody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr key={item.idvehiculo} style={{ padding: "0" }}>
                        <td className="align-baseline text-center">
                          {item.placa}
                        </td>
                        <td className="align-baseline text-center">
                          {item.ritm}
                        </td>
                        <td className="align-baseline text-center">
                          {item.nombrepropie}
                        </td>
                        <td className="align-baseline text-center">
                          {item.idvehiculo}
                        </td>

                        <td
                          className="align-baseline text-center"
                          style={{ width: "150px" }}
                        >
                          <button
                            onClick={gestionarDeuda(item)}
                            className="btn btn-sm btn-primary rounded-pill"
                          >
                            <i class="fas fa-pen-nib"></i> Actualizar
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
            }
            {props.tipo === "rentas" &&
              <TblContainer>
                <TblHead />
                <tbody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr key={item.idrentas} style={{ padding: "0" }}>
                        <td className="align-baseline text-center">
                          {item.idrentas}
                        </td>
                        <td className="align-baseline text-center">
                          {item.cedrif}
                        </td>
                        <td className="align-baseline text-center">
                          {item.nombrearrendatario}
                        </td>
                        <td className="align-baseline text-center">
                          {item.descripcion}
                        </td>

                        <td
                          className="align-baseline text-center"
                          style={{ width: "150px" }}
                        >
                          <button
                            onClick={gestionarDeuda(item)}
                            className="btn btn-sm btn-primary rounded-pill"
                          >
                            <i class="fas fa-pen-nib"></i> Actualizar
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
            }
            {props.tipo === "publicidad" &&
              <TblContainer>
                <TblHead />
                <tbody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr key={item.idcomercio} style={{ padding: "0" }}>
                        <td className="align-baseline text-center">
                          {item.idcomercio}
                        </td>
                        <td className="align-baseline text-center">
                          {item.ritm}
                        </td>
                        <td className="align-baseline text-center">
                          {item.rif}
                        </td>
                        <td className="align-baseline text-center">
                          {item.nombre}
                        </td>
                        <td className="align-baseline text-center">
                          {item.direccion}
                        </td>

                        <td
                          className="align-baseline text-center"
                          style={{ width: "150px" }}
                        >
                          <button
                            onClick={() => setMostrar2(true)}
                            className="btn btn-sm btn-primary rounded-pill"
                          >
                            <i class="fas fa-pen-nib"></i> Actualizar
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
            }
            <TblPagination />
          </div>
          <ModalGestionDeuda
            show={mostrar2}
            contribuyente={contribuyente}
            onHide={handleCancela2}
            factorcambio={factorCambio}
            tipo={props.tipo}
            permiso={permiso.permiso}
            tabla={nomtabla}
          />
          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
            }
          />
        </div>
      </div>
      <Dimmer active={activate} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaActualizarDeuda;
